import { all } from 'redux-saga/effects';
import authSagas from './auth';
import benefitsSaga from './customerBenefitSaga';

export default function* rootSaga() {
  yield all([authSagas, benefitsSaga()]);
}
